import { ComponentProps, ImgHTMLAttributes } from "react";
import { BlockTitleProps } from "@blocks/Blocks";
import Card from "@particles/card/Card";
import { ConfigurationSettings } from "@particles/configurationSettings/utils/types";
import { TRouteWithoutRedirect } from "@sphtech/web2-core/ssr";
import { DefaultNavigationData } from "@typings/Page";

export enum AwardType {
  E50 = "events-awards_enterprise-50",
  EE = "events-awards_emerging-enterprise",
  SBA = "events-awards_singapore-business-awards",
  SCA = "events-awards_singapore-corporate-awards",
  SIA = "events-awards_sustainability-impact-awards",
  DATA = "events-awards_design-ai-tech-awards",
}

export type EventsAwardsPageRowProps = {
  /** LogoAttributes to show the logo on the events awards page */
  logoAttributes: ImgHTMLAttributes<HTMLImageElement>;
  /** BlockTitleProps to show the title of the events awards page */
  blockTitleProps: BlockTitleProps;
  /** Description to show the information events awards */
  description: string;
  /** Article data to show the article card on events awards page */
  articleProps: ComponentProps<typeof Card>;
  /** Classname to add styles for events and awards page row component */
  className?: string;
};

export type EventsAwardsPageContext = TRouteWithoutRedirect<
  EventsAwardsPagePayload,
  string
>;

export type EventsAwardsPagePayload = {
  /** Events and Awards page data to show the articles for respective awards */
  data: EventsAwardsPageData;
} & ConfigurationSettings;

export type EventsAwardsPageData = {
  /** Data to display the E50 article */
  e50Article?: ComponentProps<typeof Card>;
  /** Data to display the EE article */
  eeArticle?: ComponentProps<typeof Card>;
  /** Data to display the SBA article */
  sbaArticle?: ComponentProps<typeof Card>;
  /** Data to display the SCA article */
  scaArticle?: ComponentProps<typeof Card>;
  /** Data to display the SIA article */
  siaArticle?: ComponentProps<typeof Card>;
  /** Data to display the DATA article */
  dataArticle?: ComponentProps<typeof Card>;
} & DefaultNavigationData;

export type EventsAwardsNavLogoProps = {
  /**Logo image to display awards logo on navigation bar */
  logo: string;
  /**Desktop width of the logo to display awards logo on navigation bar */
  widthDesktop: number;
  /**Mobile width of the logo to display awards logo on navigation bar */
  widthMobile: number;
  /**Desktop height of the logo to display awards logo on navigation bar */
  heightDesktop?: number;
};

export type AwardsMenu = {
  /**Text to be displayed on naviagtion bar */
  text: string;
  /**Link to navigation on respective pages from naviagtion bar */
  link: string;
  /**Flag to display item on naviagtion bar */
  enabled?: boolean;
};

export type EventsAwardsLandingPagePayload = {
  /**Events and Awards page data to show the articles for respective awards */
  data: EventsAwardsLandingPageData;
} & ConfigurationSettings;

export type EventsAwardsLandingPageData = {
  /**Type of award from events and awards */
  awardType?: AwardType;
  /**Article props to display article on SIA landing page */
  articleProps?: ComponentProps<typeof Card>;
};

export type EventsAwardsLandingPageContext = TRouteWithoutRedirect<
  EventsAwardsLandingPagePayload,
  string
>;
